<template>
	<v-card>
		<v-card-title class="error">
			<div class="headline white--text">Report an Error</div>
		</v-card-title>
		<v-card-text>
			<v-form
				v-model="valid"
				autocomplete="off"
				@submit.prevent="submit"
			>
				<v-text-field
					v-model="name"
					:rules="validate.require"
					autofocus
					name="Name"
					label="Name"
				/>
				<v-textarea
					v-model="message"
					:rules="validate.require"
					name="Message"
					label="What happened?"
				/>
			</v-form>
		</v-card-text>
		<v-divider/>
		<v-card-actions>
			<v-spacer/>
			<v-btn
				:disabled="!valid"
				color="primary"
				@click="submit"
			>
				Submit
			</v-btn>
			<v-btn
				flat
				color="error"
				@click="$emit('close')"
			>
				close
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import * as Html2Canvas from 'html2canvas';
import Validation from '@/mixins/Validation';

export default {
	mixins: [Validation],
	data() {
		return {
			name: localStorage.getItem('name') || '',
			message: '',
			valid: true,
			canvasOptions: {
				logging: false,
			},
		};
	},
	methods: {
		submit() {
			if (!this.valid) {
				return;
			}
			this.$emit('close');
			// Let close animation finish and then take snapshot/send it
			setTimeout(() => {
				this.screenShot();
			}, 400);
		},
		screenShot() {
			const opts = {
				metaData: {
					feedback: { name: this.name, message: this.message },
				},
			};
			this.notifyBugsnag(opts);
			// Html2Canvas(document.querySelector('#app'), this.canvasOptions)
			// 	.then((canvas) => {
			// 		opts.metaData.image = canvas.toDataURL();
			// 	})
			// 	.catch((e) => {
			// 		console.log(e);
			// 	})
			// 	.finally(() => {
			// 		this.notifyBugsnag(opts);
			// 	});
		},
		notifyBugsnag(opts) {
			const notified = this.$bugsnag.notify(new Error(`User Report by ${this.name}: ${this.message}`), opts);
			console.log(notified);
			this.$notify('success', 'Error report has been sent.');
		},
	},
};
</script>

<style>

</style>
